import React from 'react';

export const SectionTitle = ({ children }: { children: React.ReactNode }) => (
  <h3 className="text-lg font-medium text-gray-900 py-3 border-b border-gray-200 mb-4">
    {children}
  </h3>
);

export const Card = ({ children, className = "" }: { children: React.ReactNode, className?: string }) => (
  <div className={`bg-white rounded-lg shadow-sm border border-gray-100 p-5 ${className}`}>
    {children}
  </div>
);

export const Button = ({ 
  onClick, 
  variant = "primary", 
  size = "md", 
  children,
  className = "",
  type = "button",
  disabled = false
}: { 
  onClick?: () => void, 
  variant?: "primary" | "secondary" | "danger" | "success" | "warning" | "outline", 
  size?: "sm" | "md" | "lg", 
  children: React.ReactNode,
  className?: string,
  type?: "button" | "submit" | "reset",
  disabled?: boolean
}) => {
  const variantStyles = {
    primary: "bg-indigo-600 hover:bg-indigo-700 text-white",
    secondary: "bg-gray-100 hover:bg-gray-200 text-gray-800",
    danger: "bg-red-600 hover:bg-red-700 text-white",
    success: "bg-green-600 hover:bg-green-700 text-white",
    warning: "bg-amber-500 hover:bg-amber-600 text-white",
    outline: "bg-white hover:bg-gray-50 text-gray-700 border border-gray-300"
  };

  const sizeStyles = {
    sm: "text-xs px-2.5 py-1.5",
    md: "text-sm px-4 py-2",
    lg: "text-base px-5 py-2.5"
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`rounded-md font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 
      focus:ring-indigo-500 transition-colors ${variantStyles[variant]} ${sizeStyles[size]} ${className}
      ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
    >
      {children}
    </button>
  );
};
